export const validateUploadForm = ({ title, documents }) => {
  const errors = {};

  if (!title || title.trim().length === 0) {
    errors.title = 'Title is required.';
  }

  if (!documents || documents.length === 0) {
    errors.documents = 'Please upload at least one document before saving.';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getUploadedAt = () => {
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date());
};
